import { keHoachNamApi } from "../../../api/category/keHoachNamApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKeHoachNamActionIds } from "../../action-types/category/IKeHoachNamActions";
import { rootActions } from "../../actions/rootActions";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

export function* keHoachNamSaga(): any {
  yield takeLatest(eKeHoachNamActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(keHoachNamApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.keHoachNam.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.keHoachNam.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
